// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./Frontend/src/app.less
// module id = 6
// module chunks = 1